<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Pipeline data preview</h1>

                    <a :href="`/#/admin/integrations/pipelines/details/${tid}/${id}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        Back
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container-fluid">
            <div v-if="preview" class="row">
                <div class="col">
                    <h5>{{preview.SourceTitle}} ({{preview.SourceData?.length}})</h5>

                    <div v-if="preview.MissingSourceId" class="alert alert-danger" role="alert">
                        Missing ID column: {{preview.SourceId}}
                    </div>

                    <table v-if="preview.SourceData.length" class="table table-dark">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th v-for="h in preview.SourceHeaders">
                                    <span :class="{'fg-color-orange': preview.SourceId.includes(h)}">{{h}}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, i) in preview.SourceData">
                                <td>{{i+1}}</td>
                                <td v-for="cell in row">{{cell}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col">
                    <h5>{{preview.DestTitle}} ({{preview.DestData?.length}})</h5>

                    <div v-if="preview.MissingDestId" class="alert alert-danger" role="alert">
                        Missing ID column: {{preview.DestId}}
                    </div>

                    <table v-if="preview.DestData.length" class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th v-for="h in preview.DestHeaders">
                                    <span :class="{'fg-color-orange': preview.DestId.includes(h)}">{{h}}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, i) in preview.DestData">
                                <td>{{i+1}}</td>
                                <td v-for="cell in row">
                                    <div class="text-ellipsis">{{cell}}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminPipelineDataPreviewPage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    document.title = "Pipeline data preview"

    const tid = useOrganizationUnitId()
    const id = useId()

    const { useCurrentUserQuery, usePipelineDataPreviewQuery } = useAdminPipelineDataPreviewPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDataPreviewQueryV1, modelPipelineDataPreviewQueryV1 } = usePipelineDataPreviewQuery(id)
    const preview = computed(() => modelPipelineDataPreviewQueryV1.value)

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDataPreviewQueryV1()
    })
</script>